import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    reConciliationResponse: {}
  },
  mutations: {
    setReConciliationResponse (state, data) {
      state.reConciliationResponse = data;
    }
  },
  actions: {
    setReConciliationResponse (context, data) {
      context.commit('setReConciliationResponse', data);
    }
  },
  getters: {
    reConciliationResponse: state => {
      return state.reConciliationResponse;
    }
  }
});
